export function getSuggestedQuestionsRoutes() {
  return [
    {
      path: "/suggested-questions",
      name: "suggested-questions",
      component: () => import(/* webpackChunkName: suggested-questions-old-backend */ "./components/SuggestedQuestionsOld.vue"),
    },
  ]
}
